import React, { ComponentProps, FunctionComponent } from "react";

const UserIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M8.00002 7.99984C9.47335 7.99984 10.6667 6.8065 10.6667 5.33317C10.6667 3.85984 9.47335 2.6665 8.00002 2.6665C6.52669 2.6665 5.33335 3.85984 5.33335 5.33317C5.33335 6.8065 6.52669 7.99984 8.00002 7.99984ZM8.00002 9.33317C6.22002 9.33317 2.66669 10.2265 2.66669 11.9998V12.6665C2.66669 13.0332 2.96669 13.3332 3.33335 13.3332H12.6667C13.0334 13.3332 13.3334 13.0332 13.3334 12.6665V11.9998C13.3334 10.2265 9.78002 9.33317 8.00002 9.33317Z",
    })
  );
};

const ForwardRef = React.forwardRef(UserIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
